import HHConfirmDialog from 'components/common/HHConfirmDialog'
import { setIsUnassignConfirmDialogOpen } from 'slices/route/routingActionsSlice'
import useRouteStopOperations from 'hooks/useRouteStopOperations'
import { formatDateToBEFormatDateFns, createDateFromString } from 'utils/date'
import api from 'api'
import { invalidateWorkOrderCacheWithRetry } from 'api/cacheInvalidationTagSets'
import { setRoutingTooltipCacheByAccountId } from 'slices/customer/customerDetailsSlice'
import { get } from 'utils/lodash'
import T from 'T'
import { toast } from 'react-toastify'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import ScheduleStopDialog from 'components/route-manager/ScheduleStop/ScheduleStopDialog'

const RoutingActionsProvider = ({ children }) => {
  const dispatch = useDispatch()

  // Shared Unassign Confirm dialog state and data
  const isUnassignConfirmDialogOpen = useSelector(state => get(state, 'routingActions.unassignConfirmDialog.isOpen', false))
  const stopToBeAssigned = useSelector(state => get(state, 'routingActions.assignStopDialog.stopToBeAssigned', {}), shallowEqual)
  const actionSerializedServiceDate = useSelector(state => get(state, 'routingActions.actionSerializedServiceDate'))
  const tooltipStopCacheByAccountId = useSelector(state => get(state, 'CustomerDetails.routing.tooltipStopCacheByAccountId', {}))
  const accountId = useSelector(state => get(state, 'routingActions.unassignConfirmDialog.accountId', ''))
  const accountTooltipStopCacheByDate = get(tooltipStopCacheByAccountId, accountId, {})

  const { unassignStops, isLoading: isMoveStopsLoading } = useRouteStopOperations()

  const closeUnassignConfirmDialog = () => dispatch(setIsUnassignConfirmDialogOpen(false))

  const onUnassignConfirm = () => {
    const workOrderId = get(stopToBeAssigned, 'workOrderId') || get(stopToBeAssigned, 'id')
    const routeId = get(stopToBeAssigned, 'routeId')
    const configuredServiceEventId = get(stopToBeAssigned, 'configuredServiceEventId')
    const routeSlotId = get(stopToBeAssigned, 'routeSlotId')
    const serviceDateStr = actionSerializedServiceDate ? actionSerializedServiceDate.split('T')[0] : ''
    const serviceDate = serviceDateStr ? createDateFromString(serviceDateStr) : new Date()
    const beFormatServiceDate = formatDateToBEFormatDateFns(serviceDate)

    return unassignStops({
      routeId,
      serviceDate,
      workOrderIds: [workOrderId],
      configuredServiceEventIds: configuredServiceEventId ? [configuredServiceEventId] : [],
      routeSlotIds: routeSlotId ? [routeSlotId] : [],
    })
      .then(() => {
        toast.success(T.UNASSIGN_STOP_SUCCESS_MSG)
        invalidateWorkOrderCacheWithRetry({ dispatch, api })
        if (accountId) {
          dispatch(
            setRoutingTooltipCacheByAccountId({
              [accountId]: {
                ...accountTooltipStopCacheByDate,
                [beFormatServiceDate]: undefined,
              },
            })
          )
        }
      })
      .finally(() => {
        closeUnassignConfirmDialog()
      })
  }
  return (
    <>
      {children}
      <ScheduleStopDialog />
      <HHConfirmDialog
        isOpen={isUnassignConfirmDialogOpen}
        onClose={closeUnassignConfirmDialog}
        onConfirm={onUnassignConfirm}
        confirmTitle={T.UNASSIGN_STOP}
        confirmDescription={T.UNASSIGN_STOP_CONFIRM_MSG}
        confirmButtonTitle={T.UNASSIGN}
        ConfirmButtonProps={{ loading: isMoveStopsLoading }}
      />
    </>
  )
}

export default RoutingActionsProvider
